/*!
 * Copyright © 2018-2021. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EVehicleStatusType {
  All = 0,
  Towing = 1,
  Moving = 2,
  Idle = 3,
  Stopped = 4,
  LossOfSignal = 5,
  Private = 6,
  Panic = 7,
  Charging = 8
}

export enum EDeviceErrorType {
  All = 100,
  TrackerError = 101,
  CameraError = 102
}

export type EStatusFilterType = EVehicleStatusType | EDeviceErrorType;
